import React, { useEffect } from 'react';
import { tracking } from './data/tracking';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/sections/HeroSection';
import { TrustStrip } from './components/sections/TrustStrip';
import { ProblemsSection } from './components/sections/ProblemsSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { UnitsSection } from './components/sections/UnitsSection';
import { SamplesCarousel } from './components/sections/SamplesCarousel';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { FaqSection } from './components/sections/FaqSection';
import { ClosingSection } from './components/sections/ClosingSection';
import { SiteFooter } from './components/sections/SiteFooter';
import { StickyOfferBar } from './components/StickyOfferBar';
export function App() {
  useEffect(() => {
    initMetaPixel(tracking.metaPixelId);
  }, []);
  return <div className="min-h-full w-full overflow-x-hidden bg-cream font-sans text-petrol" data-id="element-0" data-mp="3mkrc3gqhn9b7">
      <main data-id="element-1" data-mp="3rbrbqtqzs5he">
        <HeroSection data-id="element-2" data-mp="3rdaquh0wwahl" />
        <TrustStrip data-id="element-3" data-mp="3rcswjpxt86cb" />
        <ProblemsSection data-id="element-4" data-mp="3recbnd7qcbci" />
        <SolutionSection data-id="element-5" data-mp="5orv1p50w72" />
        <UnitsSection data-id="element-6" data-mp="4wxfu7a14id" />
        <SamplesCarousel data-id="element-7" data-mp="5gbgztt38r4" />
        <BonusesSection data-id="element-8" data-mp="7stte3h7l4p" />
        <OfferSection data-id="element-9" data-mp="2zlldgx6hkckm" />
        <GuaranteeSection data-id="element-10" data-mp="2zm4vedw4z0yn" />
        <FaqSection data-id="element-11" data-mp="2zmwlj96ys6hj" />
        <ClosingSection data-id="element-12" data-mp="33mou3lwcycmw" />
      </main>
      <SiteFooter data-id="element-13" data-mp="33nq6btp41567" />
      <StickyOfferBar data-id="element-14" data-mp="33n6zb810016y" />
    </div>;
}